// Node imports
import {
  Container,
  EventConstants,
  Label,
  Linear,
  delayedCall,
  dispatcher,
  ingenuity,
  killDelayedCall,
} from "@quest/base-core";
import {
  ButtonBaseBehavior,
  IntroOutroControllerBehavior,
  MeterBitmapBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-leopard/dist/";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { GameParserModel } from "../Platform/GameParserModel";

export class IntroOutroControllerGame extends IntroOutroControllerBehavior {
  private tapToClickContainer: Container;
  private tapToClickContainerOutro: Container;
  private continueButton: ButtonBaseBehavior;
  private continueButtonOutroWin: ButtonBaseBehavior;
  private IntroText: Label;

  // ANIMATION_INTRO_START_PART_1 = "freespins_intro_bg";
  ANIMATION_INTRO_START_PART_2 = "in";
  ANIMATION_OUTRO_START = "in_bg";
  ANIMATION_OUTRO_TEXT_LOOP = "loop";
  ANIMATION_OUTRO_TEXT_START = "in";
  // ANIMATION_OUTRO_LOOP = "loop_bg";

  protected initializeElements(): void {
    this.outroImg = this.view.getImageById("FGOutroImage");
    this.fadeContainer = this.view.getContainerByID("fadeContainer");
    this.msgWindowBorderAnim = this.view.getAnimationById("MssgWindow_Border_Animation");
    this.msgWindow = this.view.getImageById("MssgWindow");
    this.introShapeBG = this.view.getShapeById("introBgAlpha");
    this.freeGameWins = this.view.getContainerByID("freeGameWinsCont");
    this.freeGameComplete = this.view.getContainerByID("freeGameCompleteCont");
    this.OutroWinAmount = this.view.getMeterById("OutroWinAmount") as MeterBitmapBehavior;
    this.OutroWinAmount.rotation = -0.16;
    this.outroWinAmount = 0;
    this.textAndNumberContainer = this.view.getContainerByID("introTextAndNumberContainer");
    this.IntroText = this.view.getLabelById("totalIntroSpins") as Label;
    this.fgOutroSpine = this.view.getSpineById("freegame_outro_Desktop");
    this.fgOutroSpineContainer = this.view.getContainerByID("fgOutroSpineContainer");
    // this.fgOutroSpine = this.fgOutroSpineContainer.children[0];
    this.outroTextSpine = this.view.getContainerByID("freegameOutroTextContainer").children[0];
    // this.outroGlassEffectSpine = this.view.getContainerByID("freegameOutroTextContainer").children[1];
    // this.freeGameIntroSpine = this.view.getContainerByID("fgIntroBgAnimDesktop").children[0];
    this.introTextSpine = this.view.getContainerByID("introSpineContainer").children[0];
    // this.introParticleSpine = this.view.getContainerByID("introTextContainer").children[1];
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
    this.tapToClickContainer = this.view.getContainerByID("taptoclickMessage");
    this.tapToClickContainerOutro = this.view.getContainerByID("OutroTapToContinue");
    this.continueButton = this.view.getButtonById("continueButtonIntro") as ButtonBaseBehavior;
  }

  protected onInitializeIntroOutro(): void {
    super.onInitializeIntroOutro();
    this.continueButton = this.view.getButtonById("continueButtonIntro") as ButtonBaseBehavior;
    this.continueButtonOutroWin = this.view.getButtonById("outro_continue_button") as ButtonBaseBehavior;
    this.continueButtonOutroWin.disableAndTint();
  }

  protected bindHandlers(): void {
    this.continueButton.on(ButtonBaseBehavior.UP, this.onContinuePressUP, this);
  }

  protected unBindHandlers(): void {
    this.continueButton.off(ButtonBaseBehavior.UP, this.onContinuePressUP, this);
  }

  /**
   * Initialize intro portrait elements
   */
  protected initializePortraitComponent() {
    this.freeGameIntroPortraitSpine = this.view.getSpineById("freespins_intro_Port_Bg");
    this.fgOutroPortraitSpine = this.view.getSpineById("freegame_outro_portrait");
  }
  protected onIntroShow() {
    ingenuity.configData.showBaseGameScreen = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
    this.IntroOutroContainer && (this.IntroOutroContainer.visible = true);
    this.IntroContainer && (this.IntroContainer.visible = true);
    this.OutroContainer && (this.OutroContainer.visible = false);
    ingenuity.currentGame.stage.addChild(this.view);
    this.IntroOutroContainer && (this.IntroOutroContainer.visible = true);
    // Neeed to call again Since when Freegame trigger second time all instance are lost and `initializeElements` called in constructor only
    this.initializeElements();
    this.OutroContainer.visible = false;
    this.introShowDelay();
    (ingenuity.parserModel as GameParserModel).getPromotionalFreeGame() &&
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
    let localizeText = ingenuity.currentGame.cache.getJSON("lang");
    this.IntroText.setText(
      String((ingenuity.parserModel as GameParserModel).getFreeSpinNum()) + "  " + localizeText.free_Spins_intro.text
    );
  }

  protected showFgOutroSpine(): void {
    this.OutroContinueBtn && (this.OutroContinueBtn.alpha = 1);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstants.UNSCBSCRIBE_METER_CONTROLLERS_FG);
    if (this.outroWinAmount) {
      this.fgOutroSpineContainer.visible = true;
      this.continueButtonOutroWin?.on(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
      this.continueButtonOutroWin?.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
      // dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_FG_OUTRO_BLUR_BG);
      if (ingenuity.deviceEnv.isDesktop) {
        this.playFgOutroDesktopSpine();
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO_FG);
        this.playFgOutroDesktopSpine();
        this.playFgOutroPortraitSpine();
      }
    } else {
      this.continueButtonOutroWin?.on(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
      this.continueButtonOutroWin?.off(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
      this.fgOutroSpineContainer.visible = false;
      this.showNoWinPopUp();
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO_FG);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FREEGAME_INTRO_BG);
    }
  }

  protected showNoWinPopUp(): void {
    this.freeGameComplete.visible = true;
    this.freeGameComplete.alpha = 0;
    const fadeInTween = ingenuity.currentGame.add
      .tween(this.freeGameComplete)
      .to({ alpha: 1 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.continueButtonOutroWin?.enableAndTint();
      this.tapToClickContainerOutro.visible = true;
    }, this);
  }

  /**
   * Add to play desktop free game intro spine animation
   */
  //override to add spine particles.
  protected playFgIntroDesktopSpine() {
    this.introTextSpine.onComplete.dispose();
    // this.freeGameIntroSpine.visible = true;
    this.introTextSpine.visible = true;
    this.introShapeBG.alpha = 0;
    this.introShapeBG.visible = true;
    const fadeInTween = ingenuity.currentGame.add.tween(this.introShapeBG);
    fadeInTween.to({ alpha: 1 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
    this.handleFgIntroSounds();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FREEGAME_INTRO_BG);
    // this.freeGameIntroSpine.playAnim(this.ANIMATION_INTRO_START_PART_1, false);
    this.introTextSpine.playAnim(this.ANIMATION_INTRO_START_PART_2, false);
    this.introTextSpine.onComplete.addOnce(() => {
      // this.freeGameIntroSpine.visible = false;
      this.continueButton.visible = true;
      this.tapToClickContainer.visible = true;
      this.introTextSpine.playAnim("static", true);
    }, this);
    // this.introParticleSpine.visible = true
    // this.introParticleSpine.playAnim("freespins_intro_particles", false);
    // this.introParticleSpine.onComplete.addOnce(() => {
    //   this.introParticleSpine.visible = false
    // }, this);
  }
  protected playFgIntroPortraitSpine() {
    this.freeGameIntroPortraitSpine.visible = true;
    this.freeGameIntroPortraitSpine.playAnim("in", false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.freeGameIntroPortraitSpine.playAnim("Static", true);
    }, this);
  }
  /**
   * to start intro sound and pause basegame sound
   */
  private handleFgIntroSounds(): void {
    if (
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)
    ) {
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstant.BASEGAME_BGMLOOP,
        gameConstants.SOUND_LIST_PRELOAD
      ).volume = 0.3;
    }
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstant.BASEGAME_BGM_INTRO,
        gameConstants.SOUND_LIST_PRELOAD
      )
    ) {
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstant.BASEGAME_BGM_INTRO,
        gameConstants.SOUND_LIST_PRELOAD
      ).volume = 0.3;
    }
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstantGame.MINIGAME_MUSIC,
        gameConstants.SOUND_LIST_POSTLOAD
      )
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.MINIGAME_MUSIC, gameConstants.SOUND_LIST_POSTLOAD);
    }
    (ingenuity.soundManager as any).playSound(SoundConstant.FREE_GAME_INTRO, 1, false, "soundList_1");
  }
  /**
   * Show FG text and number with fade in effect
   */
  protected showTextAndNumberWithFadeIn() {
    this.rotateTextAndNumber();
    this.textAndNumberContainer.visible = true;
    this.textAndNumberContainer.alpha = 0;
    this.IntroText.visible = true;
    const fadeInTween = ingenuity.currentGame.add.tween(this.textAndNumberContainer);
    fadeInTween.to({ alpha: 1 }, SlotConstantsBehavior.DURATION_500, Linear.None, true, 300, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.FREEGAME_INTRO_VOICE, 1, false, "soundList_1");
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
    }, this);
  }

  protected rotateTextAndNumber(): void {
    this.IntroText.rotation = -0.1513;
  }
  private onContinuePressUP(): void {
    this.tapToClickContainer.visible = false;
    this.continueButton.visible = false;
    this.onIntroFinishDesktop();
    this.hideTextAndNumberWithFadeOut();
  }

  protected hideTextAndNumberWithFadeOut(): void {
    const fadeOutTween = ingenuity.currentGame.add
      .tween(this.textAndNumberContainer)
      .to({ alpha: 0 }, 500, Linear.None, true, 700, 0, false);
    fadeOutTween.onComplete.addOnce(() => {
      this.IntroText.visible = false;
      fadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(fadeOutTween);
      this.onIntroContinuePressUp();
    }, this);
  }

  private onIntroFinishDesktop(): void {
    this.introTextSpine.playAnim("out", false);
    if (!ingenuity.deviceEnv.isDesktop) {
      this.freeGameIntroPortraitSpine.playAnim("out");
    }
    delayedCall(
      "alphaFadeDelay",
      SlotConstantsBehavior.DURATION_500,
      () => {
        killDelayedCall("alphaFadeDelay");
        const fadeOutTween = ingenuity.currentGame.add.tween(this.introShapeBG);
        fadeOutTween.to({ alpha: 0 }, 400, Linear.None, true, 0, 0, false);
        fadeOutTween.onComplete.addOnce(() => {
          this.introShapeBG.visible = false;
          ingenuity.currentGame.tweens.remove(fadeOutTween);
        }, this);
      },
      this
    );
    this.introTextSpine.onComplete.addOnce(() => {
      this.introTextSpine.visible = false;
    }, this);
  }
  /**
   * overrided to update flow
   */
  protected onIntroContinuePressUp() {
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
    ingenuity.soundManager.stop(SoundConstantGame.BASEGAME_BGMLOOP, "soundList");
    dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.UNSUBSCRIBE_BASEVIEW_EVENTS);
    dispatcher.fireEvent(SlotEventConstants.SHOW_FREEGAME_VIEW);
    this.resetIntroComponent();
    delayedCall(
      SlotConstantsBehavior.START_FG_SPIN_DELAY,
      SlotConstantsBehavior.DURATION_500,
      () => {
        killDelayedCall(SlotConstantsBehavior.START_FG_SPIN_DELAY);
        dispatcher.fireEvent(eventDispatchers.START_STICKY_WILD_FG);
      },
      this
    );
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BG, { name: gameConstants.FREEGAME_INTRO_BG, duration: 0 });
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_BG_SHOW);
  }
  /**
   * to set allignment on outro show
   */
  protected onOutroShow(): void {
    dispatcher.fireEvent(EventConstants.RESIZE, ingenuity.deviceEnv.update());
    super.onOutroShow();
  }
  /**
   * to play desktop spine animations
   */
  protected playFgOutroDesktopSpine() {
    // this.fgOutroSpine.setPause(false);
    this.outroTextSpine.setPause(false);
    // this.fgOutroSpine.visible = true;
    this.OutroContainer.alpha = 1;
    this.outroTextSpine.visible = true;
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BG, { name: SlotConstantsBehavior.FREEGAME_BG_SHOW, duration: 0 });
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FREEGAME_INTRO_BG);
    this.startOutroTickup();
    // this.fgOutroSpine.playAnim(this.ANIMATION_OUTRO_START, false);
    this.outroTextSpine.playAnim(this.ANIMATION_OUTRO_TEXT_START, false);
    // this.fgOutroSpine.onComplete.addOnce(() => {
    //   this.fgOutroSpine.playAnim(this.ANIMATION_OUTRO_LOOP, true);
    // }, this);
    this.outroTextSpine.onComplete.addOnce(() => {
      this.outroTextSpine.playAnim(this.ANIMATION_OUTRO_TEXT_LOOP, true);
    }, this);
    // this.outroGlassEffectSpine.visible = true;
    // this.outroGlassEffectSpine.playAnim("in_glass_effect", false);
    // this.outroGlassEffectSpine.onComplete.addOnce(() => {
    //   this.outroGlassEffectSpine.playAnim("loop_glass_effect", false);
    //   this.outroGlassEffectSpine.visible = false;
    // }, this);
  }
  /**
   * to shaw tickup with delay to sync with spine
   */
  protected startOutroTickup(): void {
    delayedCall(
      "showTickupWithDelay",
      200,
      () => {
        killDelayedCall("showTickupWithDelay");
        this.OutroWinAmount.setValue(0);
        this.OutroWinAmount.visible = true;
        this.OutroWinAmount.alpha = 1;
        this.OutroWinAmount &&
          this.OutroWinAmount.startTick(
            this.outroWinAmount,
            true,
            false,
            SlotConstantsBehavior.OUTRO_WIN_TICKUP_DURATION,
            true,
            this.showOutroWinContinueButton.bind(this)
          );
      },
      this
    );
  }

  private showOutroWinContinueButton(): void {
    this.continueButtonOutroWin.enableAndTint();
    this.tapToClickContainerOutro.visible = true;
    this.continueButtonOutroWin.visible = true;
  }

  private onOutroWinContinuePressUP(): void {
    this.tapToClickContainer.visible = false;
    this.continueButtonOutroWin.visible = false;
    ingenuity.configData.showBaseGameScreen = true;
    this.onOutroContinuePressUp();
    this.turnOffButtonHandler();
  }

  /**
   * Play fg outro portrait spine
   */
  protected playFgOutroPortraitSpine() {
    this.fgOutroPortraitSpine.setPause(false);
    this.fgOutroPortraitSpine.visible = true;

    this.fgOutroPortraitSpine.playAnim("in", false);
    this.fgOutroPortraitSpine.onComplete.addOnce(() => {
      this.fgOutroPortraitSpine.playAnim("loop", true);
    }, this);
  }
  /**
   * playFgOutroEndSpine method override to stop fgOutroSpine,fgOutroPortraitSpine animation and hide.
   */
  protected playFgOutroEndSpine(): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      this.fgOutroPortraitSpine.visible = false;
      this.fgOutroPortraitSpine.setPause(true);
    }
    const fadeOutTween = ingenuity.currentGame.add.tween(this.OutroContainer);
    fadeOutTween.to({ alpha: 0 }, 200, Linear.None, true, 0, 0, false);
    fadeOutTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeOutTween);
      this.outroTextSpine.setPause(true);
      this.outroTextSpine.visible = false;
    });
    // this.fgOutroSpine.setPause(true);
    // this.fgOutroSpine.visible = false;
  }
  /**
   * to change meter fade out functionality
   */
  protected onOutroContinuePressUp() {
    gameConstants.FREEGAME_RETURN_SOUND = true;

    this.playFgOutroEndSpine();
    delayedCall(
      SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY,
      400,
      () => {
        killDelayedCall(SlotConstantsBehavior.OUTRO_SPINE_FADE_OUT_DELAY);
        this.stopSoundAndShowBaseGame();
        delayedCall(
          SlotConstantsBehavior.OUTRO_HIDE_DELAY,
          0,
          () => {
            this.tapToClickContainerOutro.visible = false;
            this.continueButtonOutroWin.disableAndTint();
            killDelayedCall(SlotConstantsBehavior.OUTRO_HIDE_DELAY);
            dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
            dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BG, { name: gameConstants.FREEGAME_INTRO_BG, duration: 0 });
            this.fgOutroMeterFadeOut();
            this.OutroContainer.visible = false;
            this.OutroContainer.alpha = 1;
            if (ingenuity.deviceEnv.isDesktop) {
              this.fgOutroSpine.visible = false;
              this.outroTextSpine.visible = false;
            } else {
              this.fgOutroSpine.visible = false;
              this.outroTextSpine.visible = false;
              this.fgOutroPortraitSpine.visible = false;
            }
          },
          this
        );
      },
      this
    );
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
  }
  /**
   * overirided to avoid meter show
   */
  protected onOutroContinuePressUpForNoWin() {
    gameConstants.FREEGAME_RETURN_SOUND = true;
    this.stopSoundAndShowBaseGame();
    dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
    this.tapToClickContainerOutro.visible = false;
    this.OutroContinueBtn?.disableAndTint();
    this.OutroContinueBtn && (this.OutroContinueBtn.alpha = 0);
    this.OutroContainer.visible = false;
    this.freeGameComplete.visible = false;
    if (
      (ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin() ||
      (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt()
    ) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    }
    this.turnOffButtonHandler();
  }
  /**
   * Method stopSoundAndShowBaseGame overrided to update sound functionality
   */
  protected stopSoundAndShowBaseGame(): void {
    super.stopSoundAndShowBaseGame();
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstantGame.FREE_GAME_BGM,
        gameConstants.SOUND_LIST_POSTLOAD
      )
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD);
    }
    (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_OUTRO, gameConstants.SOUND_LIST_POSTLOAD);
    if (
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    }
    (ingenuity.soundManager as any).playSound(
      SoundConstant.BASEGAME_BGMLOOP,
      1,
      true,
      gameConstants.SOUND_LIST_PRELOAD
    );
  }

  private turnOffButtonHandler(): void {
    this.continueButtonOutroWin.off(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
    this.continueButtonOutroWin.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
  }
}
